import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import CompanySelectPage from './pages/CompanySelectPage';
import UsersPage from './pages/UsersPage';
import UserInfoPage from './pages/UserInfoPage';
import CompaniesPage from './pages/CompaniesPage';
import SuppliersPage from './pages/SuppliersPage';
import ClientsPage from './pages/ClientsPage';
import ClientInfoPage from './pages/ClientInfoPage';
import ClientAccountsPage from './pages/ClientAccountsPage';
import ClientAccountInfoPage from './pages/ClientAccountInfoPage';
import CategoriesPage from './pages/CategoriesPage';
import ProductsPage from './pages/ProductsPage';
import ProductInfoPage from './pages/ProductInfoPage';
import ProductDetailPage from './pages/ProductDetailPage';
import PackagingPage from './pages/PackagingPage';
import PackagingInfoPage from './pages/PackagingInfoPage';
import BrandListPage from './pages/BrandListPage';
import BrandInfoPage from './pages/BrandInfoPage';
import PurchasesPage from './pages/PurchasesPage';
import PurchaseInfoPage from './pages/PurchaseInfoPage';
import PurchaseViewPage from './pages/PurchaseViewPage';
import PurchasePaymentV2Page from './pages/PurchasePaymentV2Page';
import VendasPage from './pages/VendasPage';
import PDVPage from './pages/PDVPage';
import ReportsPage from './pages/ReportsPage';
import SalesReportPage from './pages/SalesReportPage';
import PaymentReportPage from './pages/PaymentReportPage';
import StockMovementReportPage from './pages/StockMovementReportPage';
import SettingsPage from './pages/SettingsPage';
import PaymentTypesPage from './pages/PaymentTypesPage';
import PricesPage from './pages/PricesPage';
import ProductPriceHistoryPage from './pages/ProductPriceHistoryPage';
import StockPage from './pages/StockPage';
import StockMovementPage from './pages/StockMovementPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import { authService } from './services/authService';
import CaixaPage from './pages/CaixaPage';
import CaixaMovimentacaoPage from './pages/CaixaMovimentacaoPage';
import CupomPrintPage from './pages/CupomPrintPage';
import VendaDetalhePage from './pages/VendaDetalhePage';
import SalesDashboardPage from './pages/SalesDashboardPage';
import { DASHBOARD_ROUTE } from './config/menuRoles';


const RedirectTo: React.FC<{ to: string; replace?: boolean }> = ({ to, replace }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(to, { replace: !!replace });
  }, [to, replace]);
  return null;
};

const RoleOnly: React.FC<{ roles: string[]; children: React.ReactNode }> = ({ roles, children }) => {
  const profile = authService.getUserProfile();
  if (!profile || !roles.includes(profile)) {
    return <RedirectTo to="/vendas" replace />;
  }
  return <>{children}</>;
};

function App() {
  useEffect(() => {
    // Inicializar o servi�o de autentica��o
    
  }, []);

  return (
    <Router>
      <Routes>
        {/* Rota de Login */}
        <Route path="/login" element={<LoginPage />} />
        {/* Esqueceu a senha */}
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        
        {/* Seleção de empresa (sem Layout) */}
        <Route path="/selecionar-empresa" element={
          <ProtectedRoute>
            <CompanySelectPage />
          </ProtectedRoute>
        } />
        
        {/* Rotas Protegidas com Layout */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <RedirectTo to={(() => {
              const p = authService.getUserProfile();
              return p === 'VENDEDOR' ? '/vendas' : DASHBOARD_ROUTE;
            })()} replace />
          </ProtectedRoute>
        } />
        
        {/* Rota padr�o redireciona para dashboard se autenticado, sen�o para login */}
        <Route path="/" element={
          authService.isAuthenticated() ? (
            authService.getCompanyId() ? (
              <RedirectTo to={(() => {
                const p = authService.getUserProfile();
                return p === 'VENDEDOR' ? '/vendas' : DASHBOARD_ROUTE;
              })()} replace />
            ) : (
              <RedirectTo to="/selecionar-empresa" replace />
            )
          ) : (
            <RedirectTo to="/login" replace />
          )
        } />
        
        {/* Outras rotas protegidas */}
        <Route path="/usuarios" element={
          <ProtectedRoute>
            <Layout>
              <UsersPage />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/usuarios/novo" element={
          <ProtectedRoute>
            <Layout>
              <UserInfoPage />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/usuarios/:id" element={
          <ProtectedRoute>
            <Layout>
              <UserInfoPage />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/empresas" element={
          <ProtectedRoute>
            <Layout>
              <CompaniesPage />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/fornecedores" element={
          <ProtectedRoute>
            <Layout>
              <SuppliersPage />
            </Layout>
          </ProtectedRoute>
        } />

        {/* Clientes */}
        <Route path="/clientes" element={
          <ProtectedRoute>
            <Layout>
              <ClientsPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/clientes/contas" element={
          <ProtectedRoute>
            <Layout>
              <ClientAccountsPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/clientes/novo" element={
          <ProtectedRoute>
            <Layout>
              <ClientInfoPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/clientes/:id" element={
          <ProtectedRoute>
            <Layout>
              <ClientInfoPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/clientes/:id/conta" element={
          <ProtectedRoute>
            <Layout>
              <ClientAccountInfoPage />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/categorias" element={
          <ProtectedRoute>
            <Layout>
              <CategoriesPage />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/produtos" element={
          <ProtectedRoute>
            <Layout>
              <ProductsPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/produtos/novo" element={
          <ProtectedRoute>
            <Layout>
              <ProductInfoPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/produtos/:id" element={
          <ProtectedRoute>
            <Layout>
              <ProductInfoPage />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/produtos/:id/visualizar" element={
          <ProtectedRoute>
            <Layout>
              <ProductDetailPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/embalagens" element={
          <ProtectedRoute>
            <Layout>
              <PackagingPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/embalagens/novo" element={
          <ProtectedRoute>
            <Layout>
              <PackagingInfoPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/embalagens/:id" element={
          <ProtectedRoute>
            <Layout>
              <PackagingInfoPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/marcas" element={
          <ProtectedRoute>
            <Layout>
              <BrandListPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/marcas/novo" element={
          <ProtectedRoute>
            <Layout>
              <BrandInfoPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/marcas/:id" element={
          <ProtectedRoute>
            <Layout>
              <BrandInfoPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/compras" element={
          <ProtectedRoute>
            <Layout>
              <PurchasesPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/compras/novo" element={
          <ProtectedRoute>
            <Layout>
              <PurchaseInfoPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/compras/:id" element={
          <ProtectedRoute>
            <Layout>
              <PurchaseInfoPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/compras/:id/visualizar" element={
          <ProtectedRoute>
            <Layout>
              <PurchaseViewPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/compras/:id/pagamento" element={
          <ProtectedRoute>
            <Layout>
              <PurchasePaymentV2Page />
            </Layout>
          </ProtectedRoute>
        } />

        {/* Estoque */}
        <Route path="/estoque" element={
          <ProtectedRoute>
            <Layout>
              <StockPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/estoque/movimentacoes" element={
          <ProtectedRoute>
            <Layout>
              <StockMovementPage />
            </Layout>
          </ProtectedRoute>
        } />

        {/* Variante com produto no path */}
        <Route path="/estoque/movimentacoes/produto/:id" element={
          <ProtectedRoute>
            <Layout>
              <StockMovementPage />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/vendas" element={
          <ProtectedRoute>
            <Layout>
              <VendasPage />
            </Layout>
          </ProtectedRoute>
        } />

        {/* Dashboard de Vendas (precisa estar antes de /vendas/:id para evitar colisão) */}
        <Route path="/vendas/dashboard" element={
          <ProtectedRoute>
            <RoleOnly roles={["ADMIN","GERENTE"]}>
              <Layout>
                <SalesDashboardPage />
              </Layout>
            </RoleOnly>
          </ProtectedRoute>
        } />

        <Route path="/vendas/:id" element={
          <ProtectedRoute>
            <Layout>
              <VendaDetalhePage />
            </Layout>
          </ProtectedRoute>
        } />

        {/* PDV em janela separada, sem Layout */}
        <Route path="/pdv" element={
          <ProtectedRoute>
            <PDVPage />
          </ProtectedRoute>
        } />
        <Route path="/pdv/cupom/:id" element={
          <ProtectedRoute>
            <CupomPrintPage />
          </ProtectedRoute>
        } />
        
        <Route path="/relatorios" element={
          <ProtectedRoute>
            <Layout>
              <ReportsPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/relatorios/vendas" element={
          <ProtectedRoute>
            <Layout>
              <SalesReportPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/relatorios/pagamentos" element={
          <ProtectedRoute>
            <Layout>
              <PaymentReportPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/relatorios/estoque-movimentos" element={
          <ProtectedRoute>
            <Layout>
              <StockMovementReportPage />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/configuracoes" element={
          <ProtectedRoute>
            <Layout>
              <SettingsPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/configuracoes/tipos-pagamento" element={
          <ProtectedRoute>
            <Layout>
              <PaymentTypesPage />
            </Layout>
          </ProtectedRoute>
        } />

        {/* Preços */}
        <Route path="/precos" element={
          <ProtectedRoute>
            <Layout>
              <PricesPage />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/precos/produto/:id/historico" element={
          <ProtectedRoute>
            <Layout>
              <ProductPriceHistoryPage />
            </Layout>
          </ProtectedRoute>
        } />

        {/* Caixa */}
        <Route path="/caixas" element={
          <ProtectedRoute>
            <Layout>
              <CaixaPage />
            </Layout>
          </ProtectedRoute>
        } />

        {/* Redirect para compatibilidade antiga */}
        <Route path="/caixa" element={<RedirectTo to="/caixas" replace />} />

        <Route path="/caixas/:id/movimentacoes" element={
          <ProtectedRoute>
            <Layout>
              <CaixaMovimentacaoPage />
            </Layout>
          </ProtectedRoute>
        } />


        <Route path="/relatorios" element={
          <ProtectedRoute>
            <Layout>
              <ReportsPage />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/configuracoes" element={
          <ProtectedRoute>
            <Layout>
              <SettingsPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/configuracoes/tipos-pagamento" element={
          <ProtectedRoute>
            <Layout>
              <PaymentTypesPage />
            </Layout>
          </ProtectedRoute>
        } />

        {/* Preços */}
        <Route path="/precos" element={
          <ProtectedRoute>
            <Layout>
              <PricesPage />
            </Layout>
          </ProtectedRoute>
        } />

        {/* Caixa */}
        <Route path="/caixas" element={
          <ProtectedRoute>
            <Layout>
              <CaixaPage />
            </Layout>
          </ProtectedRoute>
        } />

        {/* Caixa removido */}
      </Routes>
    </Router>
  );
}

export default App;
